import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Importer Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'

// Importer le CSS personnalisé
import '@/assets/css/style.css'

// Importer Owl Carousel CSS
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

// Importer Animate.css
import 'animate.css';
import WOW from 'wow.js';

// Initialize WOW.js
const wow = new WOW();

// Fonction pour initialiser l'application après le chargement des données
async function initializeApp() {
  try {
    // Charger toutes les données avant de monter l'application
    await store.dispatch('fetchAllData')

    const app = createApp(App)
    app.use(store)
    app.use(router)
    app.use(wow)
    app.mount('#app')

    // Initialize WOW.js after the app is mounted
    wow.init();
  } catch (error) {
    console.error('Failed to initialize app:', error)
    // Même en cas d'erreur, on monte l'application pour afficher un message d'erreur
    const app = createApp(App)
    app.use(store)
    app.use(router)
    app.use(wow)
    app.mount('#app')
    wow.init();
  }
}

// Démarrer l'initialisation de l'application
initializeApp();
